import { baseTheme } from '@jetshop/ui/BaseTheme';

import { createBreakpointHelpers } from '@jetshop/ui/utils/breakpoints';
export const labels = ['xs', 'sm', 'md', 'lg'];
const breakpoints = ['20rem', '40rem', '74rem', '75rem'];
const { breakpointMap, above, below, between, only } = createBreakpointHelpers(
  labels,
  breakpoints
);

const colors = {
  ...baseTheme.colors,
  red: '#cd3132',
  blue: '#2f80ed',
  green: '#00b55b',
  font: '#212121',
  buy: '#00b55b',
  dark: '#000',
  darkGrey: '#212121',
  light: '#fff',
  discountedPrice: '#e01527',
  lightGrey: '#646464',
  eyeWearYellow: '#f9b233',
  gray: ['#444444', '#666666', '#888888', '#aaaaaa', '#cccccc', '#eeeeee', '#f4f4f4']


};

const spaces = {
  none: '0',
  xxs: '4px',
  xs: '8px',
  sm: '16px',
  md: '24px',
  lg: '32px',
  xl: '40px',
  xxl: '48px',
};

const sizes = {
  uspHeight: '54px',
  menuHeight: '75px',
  navHeight: '40px',
};

const general = {
  maxWidth: '80em',
};

export const SkoterdelenTheme = {
  ...baseTheme,
  general,
  spaces,
  colors,
  sizes,
  labels,
  breakpoints,
  breakpointMap,
  above,
  below,
  between,
  only,
  font: {
    primary: 'Abel,sans-serif',
  },
};
